/* Shiny Leaf — Bariatric PDP redesign (draft) */
(function () {
  function money(cents) {
    var fmt = (window.Shopify && Shopify.money_format) || '${{amount}}';
    var v = (Math.round(cents) / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function embedSrc(id, type) {
    if (type === 'vimeo') return 'https://player.vimeo.com/video/' + id + '?autoplay=1';
    return 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
  }

  function embedMuted(id, type) {
    if (type === 'vimeo') return 'https://player.vimeo.com/video/' + id + '?autoplay=1&muted=1&loop=1&playsinline=1';
    return 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&mute=1&playsinline=1&loop=1&playlist=' + id + '&rel=0&modestbranding=1&cc_load_policy=1';
  }
  /* YouTube/Vimeo commercial: start muted when scrolled into view (viewer unmutes with the player's controls) */
  function initAutoplay() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-slp-autoplay]').forEach(function (btn) {
      if (btn.__slpA) return; btn.__slpA = true;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting || !btn.isConnected) return;
        io.disconnect();
        var f = document.createElement('iframe');
        f.src = embedMuted(btn.getAttribute('data-slp-video'), btn.getAttribute('data-slp-video-type'));
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true; f.title = btn.getAttribute('aria-label') || 'Product video';
        btn.replaceWith(f);
      }, { threshold: 0.5 });
      io.observe(btn);
    });
  }
  function initVideos(scope) {
    scope.querySelectorAll('[data-slp-video]').forEach(function (btn) {
      if (btn.__slp) return; btn.__slp = true;
      btn.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = embedSrc(btn.getAttribute('data-slp-video'), btn.getAttribute('data-slp-video-type'));
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.title = btn.getAttribute('aria-label') || 'Product video';
        btn.replaceWith(f);
      });
    });
  }

  function initGallery(root) {
    var slides = root.querySelectorAll('[data-slp-slide]');
    var thumbs = root.querySelectorAll('[data-slp-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-slp-thumb');
        slides.forEach(function (s) {
          var on = s.getAttribute('data-slp-slide') === i;
          s.classList.toggle('is-active', on);
          if (!on) { var mv = s.querySelector('video'); if (mv) mv.pause(); }
          if (!on) { var fr = s.querySelector('iframe'); if (fr) { var src = fr.src; fr.src = ''; fr.src = src.replace('autoplay=1', 'autoplay=0'); } }
        });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  }


  /* quantity breaks (one-time only; discounts are native automatic discounts) */
  function Qty(root, onChange) {
    var box = root.querySelector('[data-slp-qty]'); if (!box) return null;
    var opts = Array.prototype.slice.call(box.querySelectorAll('.slp-qty-o'));
    var subNote = box.querySelector('[data-slp-qty-sub]'), note = box.querySelector('[data-slp-qty-note]');
    var off = false;
    function cur() { return opts.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0] || opts[0]; }
    function calc(unit, o) { var q = +o.dataset.q, sub = unit * q, d = q * Math.floor(unit * (+o.dataset.pct) / 100); /* matches Shopify: per-unit discount, rounded down */ return { q: q, sub: sub, total: sub - d }; }
    opts.forEach(function (o) { o.addEventListener('click', function () { if (off) return; opts.forEach(function (x) { x.setAttribute('aria-checked', x === o ? 'true' : 'false'); }); onChange(); }); });
    return {
      q: function () { return off ? 1 : +cur().dataset.q; },
      total: function (unit) { return off ? unit : calc(unit, cur()).total; },
      render: function (unit, disabled) {
        off = !!disabled;
        box.classList.toggle('is-off', off);
        if (subNote) subNote.hidden = !off; if (note) note.hidden = off;
        opts.forEach(function (o) {
          var c = calc(unit, o);
          o.disabled = off;
          o.querySelector('[data-slp-qty-total]').textContent = money(c.total);
          o.querySelector('[data-slp-qty-was]').textContent = c.total < c.sub ? money(c.sub) : '';
          o.querySelector('[data-slp-qty-each]').textContent = money(Math.round(c.total / c.q)) + ' each';
        });
      }
    };
  }


  /* show subscription frequency as tappable pills (the select stays the source of truth) */
  function syncFreqPills(sel) {
    if (!sel) return;
    var wrap = sel.parentNode.querySelector('.slp-freq-pills');
    if (!wrap) { wrap = document.createElement('div'); wrap.className = 'slp-freq-pills'; wrap.setAttribute('role', 'radiogroup'); wrap.setAttribute('aria-label', 'Delivery frequency'); sel.parentNode.appendChild(wrap); sel.classList.add('slp-freq-native'); }
    wrap.innerHTML = '';
    Array.prototype.forEach.call(sel.options, function (o) {
      if (o.disabled) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'slp-freq-pill'; b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', o.value === sel.value ? 'true' : 'false');
      b.textContent = o.textContent;
      b.addEventListener('click', function () { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); syncFreqPills(sel); });
      wrap.appendChild(b);
    });
  }

  function initBuyBox(root) {
    var plans = Array.prototype.slice.call(root.querySelectorAll('[data-slp-plan]'));
    if (!plans.length) return;
    var sw = root.querySelector('[data-slp-switch]');
    var idInput = root.querySelector('[data-slp-id]');
    var spInput = root.querySelector('[data-slp-sp]');
    var note = root.querySelector('[data-slp-note]');
    var btnPrice = root.querySelector('[data-slp-btn-price]');
    var sticky = root.querySelector('[data-slp-sticky]');
    var addBtn = root.querySelector('[data-slp-add]');
    var base = null;
    plans.forEach(function (p) { if (+p.dataset.count === 30) base = +p.dataset.once / 30; });
    var subOn = sw.getAttribute('aria-checked') === 'true';
    if (!plans.some(function (p) { return !!p.dataset.plan; })) { subOn = false; var row = sw.closest('.slp-sub'); if (row) row.hidden = true; }
    var qty = Qty(root, function () { render(); });
    var freq = root.querySelector('[data-slp-freq]'), fsel = root.querySelector('[data-slp-freq-select]'), chosen = null;
    function allocsOf(p) { return (p.dataset.allocs || '').split(';').filter(Boolean).map(function (x) { var a = x.split('|'); return { id: a[0], name: a[1].replace(/^Delivery\s+/i, ''), price: +a[2] }; }); }
    if (fsel) fsel.addEventListener('change', function () { chosen = fsel.value; render(); });

    function render() {
      plans.forEach(function (p) { p.hidden = subOn && !p.dataset.plan; p.style.display = p.hidden ? 'none' : ''; });
      var cur = plans.filter(function (p) { return p.getAttribute('aria-checked') === 'true'; })[0] || plans[0];
      if (cur.hidden) {
        var alt = plans.filter(function (p) { return !p.hidden && +p.dataset.count === 90; })[0] || plans.filter(function (p) { return !p.hidden; })[0] || cur;
        plans.forEach(function (x) { x.setAttribute('aria-checked', x === alt ? 'true' : 'false'); });
        cur = alt;
      }
      plans.forEach(function (p) {
        var hasSub = !!p.dataset.plan;
        var useSub = subOn && hasSub;
        var now = useSub ? +p.dataset.sub : +p.dataset.once;
        var perDay = now / +p.dataset.count;
        p.querySelector('[data-slp-now]').textContent = money(now);
        var was = p.querySelector('[data-slp-was]'); was.hidden = !useSub;
        p.querySelector('[data-slp-day]').textContent = money(perDay) + '/day';
        var save = base ? Math.round((1 - perDay / base) * 100) : 0;
        var sb = p.querySelector('[data-slp-save]');
        sb.hidden = save <= 0; sb.textContent = 'SAVE ' + save + '%';
      });
      var curHasSub = !!cur.dataset.plan; var subPriceEl = root.querySelector('[data-slp-sub-price]'); if (subPriceEl) subPriceEl.textContent = subOn ? (curHasSub ? money(+cur.dataset.sub) : '—') : '';
      var useSub = subOn && curHasSub;
      var price = useSub ? +cur.dataset.sub : +cur.dataset.once;
      var planId = cur.dataset.plan;
      if (fsel && freq) {
        var al = allocsOf(cur);
        freq.hidden = !(useSub && al.length > 1);
        if (useSub && al.length) {
          fsel.innerHTML = al.map(function (a) { return '<option value="' + a.id + '">' + a.name + '</option>'; }).join('');
          var pick = al.filter(function (a) { return a.id === chosen; })[0] || al.filter(function (a) { return a.id === cur.dataset.plan; })[0] || al[0];
          fsel.value = pick.id; planId = pick.id; price = pick.price;
          cur.querySelector('[data-slp-now]').textContent = money(pick.price);
          syncFreqPills(fsel);
        }
      }
      idInput.value = cur.dataset.variant;
      spInput.value = useSub ? planId : '';
      note.hidden = !(subOn && !curHasSub);
      if (qty) { qty.render(+cur.dataset.once, useSub); price = qty.total(price); }
      btnPrice.textContent = money(price);
      addBtn.disabled = cur.disabled;
      if (sticky) {
        sticky.querySelector('[data-slp-sticky-name]').textContent = cur.dataset.name + (useSub ? ' · Subscribe' : '');
        var qn = qty ? qty.q() : 1;
        sticky.querySelector('[data-slp-sticky-day]').textContent = qn > 1 ? qn + ' × ' + cur.dataset.name : money(price / +cur.dataset.count) + '/day';
        sticky.querySelector('[data-slp-sticky-price]').textContent = money(price);
      }
    }

    var err = root.querySelector('[data-slp-error]');
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var item = { id: +idInput.value, quantity: spInput.value || !qty ? 1 : qty.q() };
      if (spInput.value) item.selling_plan = +spInput.value;
      addBtn.disabled = true; err.hidden = true;
      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function () { if (window.slAfterAdd) window.slAfterAdd(addBtn); else window.location.href = window.slCartUrl || (root_url + 'cart'); })
        .catch(function (e) { err.textContent = (e && (e.description || e.message)) || 'Something went wrong. Please try again.'; err.hidden = false; addBtn.disabled = false; });
    });

    plans.forEach(function (p) {
      p.addEventListener('click', function () {
        plans.forEach(function (x) { x.setAttribute('aria-checked', x === p ? 'true' : 'false'); });
        render();
      });
    });
    sw.addEventListener('click', function () {
      subOn = !subOn; sw.setAttribute('aria-checked', subOn ? 'true' : 'false'); render();
    });

    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(addBtn);
      sticky.querySelector('[data-slp-sticky-add]').addEventListener('click', function () { addBtn.click(); });
    }
    render();
  }

  function cartAdd(item, btn, err) {
    btn.disabled = true; if (err) err.hidden = true;
    var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { if (window.slAfterAdd) window.slAfterAdd(btn); else window.location.href = window.slCartUrl || (root_url + 'cart'); })
      .catch(function (e) { if (err) { err.textContent = (e && (e.description || e.message)) || 'Something went wrong. Please try again.'; err.hidden = false; } btn.disabled = false; });
  }

  /* generic buy box (any product) */
  function initBuy(root) {
    var vars = Array.prototype.slice.call(root.querySelectorAll('[data-slp-variant]'));
    if (!vars.length) return;
    var modes = Array.prototype.slice.call(root.querySelectorAll('[data-slp-mode]'));
    var freq = root.querySelector('[data-slp-freq]');
    var sel = root.querySelector('[data-slp-freq-select]');
    var addBtn = root.querySelector('[data-slp-add]');
    var btnPrice = root.querySelector('[data-slp-btn-price]');
    var note = root.querySelector('[data-slp-note]');
    var err = root.querySelector('[data-slp-error]');
    var sticky = root.querySelector('[data-slp-sticky]');
    var mode = 'once';
    var qty = Qty(root, function () { render(); });
    function cur() { return vars.filter(function (v) { return v.getAttribute('aria-checked') === 'true'; })[0] || vars[0]; }
    function plansOf(v) { return (v.dataset.plans || '').split(',').filter(Boolean); }
    function render() {
      var v = cur(), plans = plansOf(v), canSub = plans.length > 0;
      modes.forEach(function (m) {
        var isSub = m.dataset.slpMode === 'sub';
        if (isSub) m.disabled = !canSub;
        if (isSub && !canSub && mode === 'sub') mode = 'once';
        var p = m.querySelector('[data-slp-mode-price]'), w = m.querySelector('[data-slp-mode-was]');
        if (isSub) { p.textContent = canSub ? money(+v.dataset.sub) : '—'; if (w) w.textContent = canSub ? money(+v.dataset.once) : ''; }
        else p.textContent = money(+v.dataset.once);
      });
      modes.forEach(function (m) { m.setAttribute('aria-checked', m.dataset.slpMode === mode ? 'true' : 'false'); });
      vars.forEach(function (x) {
        var n = x.querySelector('[data-slp-now]'); if (!n) return;
        var xs = mode === 'sub' && plansOf(x).length;
        n.textContent = money(xs ? +x.dataset.sub : +x.dataset.once);
        var w = x.querySelector('[data-slp-was]'); if (w) w.hidden = !xs;
      });
      if (sel) {
        Array.prototype.forEach.call(sel.options, function (o) { o.disabled = plans.indexOf(o.value) < 0; });
        var so = sel.options[sel.selectedIndex];
        if (!so || so.disabled) { var f = Array.prototype.filter.call(sel.options, function (o) { return !o.disabled; })[0]; if (f) sel.value = f.value; }
        syncFreqPills(sel);
      }
      if (freq) freq.hidden = mode !== 'sub';
      if (note) note.hidden = !(modes.length && !canSub && vars.length > 1);
      var price = mode === 'sub' ? +v.dataset.sub : +v.dataset.once;
      if (qty) { qty.render(+v.dataset.once, mode === 'sub'); price = qty.total(price); }
      btnPrice.textContent = money(price);
      var pl = root.getAttribute('data-slp-price-label');
      if (pl) {
        btnPrice.textContent = pl;
        vars.forEach(function (x) { var n = x.querySelector('[data-slp-now]'), w = x.querySelector('[data-slp-was]'); if (n) n.textContent = pl; if (w) { w.textContent = money(+x.dataset.once); w.hidden = false; } });
      }
      addBtn.disabled = v.hasAttribute('data-soldout');
      if (sticky) {
        var nm = sticky.querySelector('[data-slp-sticky-name]');
        if (vars.length > 1) nm.textContent = v.dataset.name;
        var qn = qty ? qty.q() : 1;
        sticky.querySelector('[data-slp-sticky-day]').textContent = mode === 'sub' ? 'Subscribe & save' : (qn > 1 ? 'Qty ' + qn + ' · one-time' : 'One-time purchase');
        sticky.querySelector('[data-slp-sticky-price]').textContent = pl || money(price);
      }
    }
    vars.forEach(function (x) { x.addEventListener('click', function () { if (x.disabled) return; vars.forEach(function (y) { y.setAttribute('aria-checked', y === x ? 'true' : 'false'); }); render(); }); });
    modes.forEach(function (m) { m.addEventListener('click', function () { if (m.disabled) return; mode = m.dataset.slpMode; render(); }); });
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var item = { id: +cur().dataset.variant, quantity: mode === 'sub' || !qty ? 1 : qty.q() };
      if (mode === 'sub' && sel && sel.value) item.selling_plan = +sel.value;
      cartAdd(item, addBtn, err);
    });
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0], show = !e.isIntersecting;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      io.observe(addBtn);
      sticky.querySelector('[data-slp-sticky-add]').addEventListener('click', function () { addBtn.click(); });
    }
    render();
  }

  /* hide the customer-video section when the product has no videos */
  function initUgc() {
    document.querySelectorAll('[data-slp-ugc]').forEach(function (u) {
      if (u.__slp) return; u.__slp = true;
      if (window.Shopify && Shopify.designMode) return;
      var body = u.querySelector('[data-slp-ugc-body]'), tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (body && body.offsetHeight >= 120) { clearInterval(iv); u.classList.remove('is-empty'); return; }
        if (tries >= 20) { clearInterval(iv); u.classList.add('is-empty'); }
      }, 1000);
    });
  }


  /* commercial band: muted autoplay while in view, tap for sound */
  function initFilm() {
    document.querySelectorAll('[data-slp-film]').forEach(function (box) {
      if (box.__slp) return; box.__slp = true;
      var v = box.querySelector('video'), snd = box.querySelector('[data-slp-film-snd]'), bar = box.querySelector('[data-slp-film-bar]');
      if (!v) return;
      v.muted = true; v.setAttribute('muted', ''); v.removeAttribute('autoplay'); v.controls = false;
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      if ('IntersectionObserver' in window && !reduce) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.5) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        }, { threshold: [0, 0.5] }).observe(box);
      }
      v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
      v.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
      if (snd) snd.addEventListener('click', function () {
        v.muted = !v.muted;
        if (!v.muted) { v.currentTime = 0; v.play(); }
        snd.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        snd.querySelector('[data-off]').hidden = !v.muted; snd.querySelector('[data-on]').hidden = v.muted;
      });
    });
  }
  function init() {
    document.querySelectorAll('[data-slp-root]').forEach(function (root) {
      if (root.__slp) return; root.__slp = true;
      initGallery(root); if (root.hasAttribute('data-slp-buy')) initBuy(root); else initBuyBox(root);
    });
    initAutoplay();
    initVideos(document);
    initFilm();
    initUgc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
